import React, { FC } from 'react';

import * as S from './helpFooter.styles';

const HelpFooter: FC = () => {
  return (
    <S.FooterWrapper>
      <S.FooterText>
        Questions? Please contact
        <S.FooterLink href="mailto:help@seddi.com"> help@seddi.com</S.FooterLink>
      </S.FooterText>
    </S.FooterWrapper>
  );
};

export { HelpFooter };
